/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 创建订单结论
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  key: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.CreateOrderResponse;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/quick-order/result/${key}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
